export default __webpack_public_path__ + "static/media/proj13.7196b075.png";